import { RootState } from 'duck/store'

export function getDataState(state: RootState) {
  return state.data
}
